document.addEventListener('click', function (event) {
  var button = event.target.closest('.buy-now-button');
  if (!button || button.disabled) return;

  event.preventDefault();

  var form = button.closest('form');
  if (!form) return;

  var idInput = form.querySelector('[name="id"]');
  var qtyInput = form.querySelector('[name="quantity"]');
  var variantId = idInput ? idInput.value : null;
  var quantity = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;

  if (!variantId) return;

  var originalText = button.textContent;
  button.disabled = true;
  button.textContent = '...';

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items: [{ id: variantId, quantity: quantity }] })
  })
    .then(function (response) {
      if (!response.ok) throw new Error('add to cart failed');
      window.location.href = '/checkout';
    })
    .catch(function () {
      button.disabled = false;
      button.textContent = originalText;
      window.location.href = '/cart';
    });
});
